<script>
    import Spinner from 'svelte-spinner';
    import { createEventDispatcher } from 'svelte';
    
    import ContactModal from '../../../modal/ContactModal.svelte';
    import ContactNote from "./ContactNote.svelte";

    const dispatch = createEventDispatcher();

    export let inmateUrn;
    export let contactNotes;
    
    let selectedContact = null;
    let isPanelCollapsed = true;
    let displayCount = 3;

    $: displayedContactNotes = contactNotes ? contactNotes.slice(0, displayCount) : null;

    $: latestContactId = contactNotes ? contactNotes[0].contactId : null;

    function loadMoreNotes() {
        isPanelCollapsed = false;
        displayCount += 2;
    }

    function openModal(contact) {
        selectedContact = { headerText: 'Contact', inmateUrn: inmateUrn, inmateName: null, canAddContact: contact.contactId === latestContactId,
            contactId: contact.contactId, contactDateTime: contact.contactDateTime, previousNotes: contact.contactNotes,
            staff: contact.contactStaffName, dueDate: contact.actionDueDate, previousAction: contact.actionNotes,
            overdueDays : contact.overdueDays, targetedTotalIncreased : contact.targetedTotalIncreased,
            isolationIncreased : contact.isolationIncreased };
    }

    function closeModal(event) {
        selectedContact = null;

        if (event.detail.refresh) {
            dispatch('update');
        }
    }
</script>

<style>
    .contact-notes-widget {
        display: flex;
        flex-direction: column;
    }
    
    #load-contact-notes {
        margin: 5px 0 15px 0;
        color: #0267B3;
        font-size: 11px;
        width: 100%;
        text-align: center;
    }
</style>

<div class="contact-notes-widget">
    {#if contactNotes}
        {#each displayedContactNotes as contactNote}

            <!-- Show follow up action as an upcoming contact -->
            {#if contactNote.contactId === latestContactId && contactNote.actionDueDate}
                <ContactNote note={contactNote.actionNotes} on:click={() => {openModal(contactNote)}} 
                    date={contactNote.actionDueDate} upcoming={true} overdueDays={contactNote.overdueDays}
                    id={`contact-list-${contactNote.contactId}-follow-up`}  />
            {/if}

            <ContactNote note={contactNote.contactNotes} date={contactNote.contactDateTime}
                id={`contact-list-${contactNote.contactId}`} on:click={() => {openModal(contactNote)}}
                overdueDays={contactNote.overdueDays} targetedTotalIncreased={contactNote.targetedTotalIncreased}
                isolationIncreased={contactNote.isolationIncreased} />
        {/each}

        {#if !(displayCount >= contactNotes.length)}
            <button id="load-contact-notes" class="button-reset focus-outline" on:click={() => loadMoreNotes()}>
                Show More
            </button>
        {/if}
    {:else}
        <div class="widget-spinner">
            <Spinner size="100" speed="750" color="#3d5980" thickness="3" gap="15" />
        </div>
    {/if}
</div>

{#if selectedContact}
    <ContactModal {...selectedContact} on:close={closeModal} />
{/if}